define(["exports", "./l10n", "hyperhtml", "./pubsubhub", "./utils"], function (_exports, _l10n, _hyperhtml, _pubsubhub, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.name = void 0;
  _hyperhtml = _interopRequireDefault(_hyperhtml);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _templateObject2() {
    const data = _taggedTemplateLiteral(["\n        <summary>\n          tests: ", "\n        </summary>\n        <ul>", "</ul>\n      "]);

    _templateObject2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject() {
    const data = _taggedTemplateLiteral(["\n    <a href=\"", "\">\n      ", "\n    </a> ", "\n  "]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

  const l10n = {
    en: {
      missing_test_suite_uri: "Found tests in your spec, but missing '" + "[`testSuiteURI`](https://github.com/w3c/respec/wiki/testSuiteURI)' in your ReSpec config.",
      tests: "tests",
      test: "test"
    }
  };
  const name = "core/data-tests";
  _exports.name = name;
  const lang = _l10n.lang in l10n ? _l10n.lang : "en";

  function toListItem(href) {
    const emojiList = [];
    const [testFile] = new URL(href).pathname.split("/").reverse();
    const testParts = testFile.split(".");
    let [testFileName] = testParts;
    const isSecureTest = testParts.find(part => part === "https");

    if (isSecureTest) {
      const requiresConnectionEmoji = document.createElement("span");
      requiresConnectionEmoji.textContent = "🔒";
      requiresConnectionEmoji.setAttribute("aria-label", "requires a secure connection");
      requiresConnectionEmoji.setAttribute("title", "Test requires HTTPS");
      testFileName = testFileName.replace(".https", "");
      emojiList.push(requiresConnectionEmoji);
    }

    const isManualTest = testFileName.split(".").join("-").split("-").find(part => part === "manual");

    if (isManualTest) {
      const manualPerformEmoji = document.createElement("span");
      manualPerformEmoji.textContent = "💪";
      manualPerformEmoji.setAttribute("aria-label", "the test must be run manually");
      manualPerformEmoji.setAttribute("title", "Manual test");
      testFileName = testFileName.replace("-manual", "");
      emojiList.push(manualPerformEmoji);
    }

    const testList = _hyperhtml.default.bind(document.createElement("li"))(_templateObject(), href, testFileName, emojiList);

    return testList;
  }

  function run(conf) {
    /** @type {NodeListOf<HTMLElement>} */
    const testables = document.querySelectorAll("[data-tests]");

    if (!testables.length) {
      return;
    }

    if (!conf.testSuiteURI) {
      (0, _pubsubhub.pub)("error", l10n[lang].missing_test_suite_uri);
      return;
    }

    Array.from(testables).filter(elem => elem.dataset.tests) // Render details + ul, returns HTMLDetailsElement
    .map(elem => {
      const details = document.createElement("details");

      const renderer = _hyperhtml.default.bind(details);

      const testURLs = elem.dataset.tests.split(/,/gm).map(url => url.trim()).map(url => {
        let href = "";

        try {
          href = new URL(url, conf.testSuiteURI).href;
        } catch (_unused) {
          (0, _pubsubhub.pub)("warn", "".concat(l10n[lang].bad_uri, ": ").concat(url));
        }

        return href;
      });
      const duplicates = testURLs.filter((links, i, self) => self.indexOf(links) !== i);

      if (duplicates.length) {
        (0, _utils.showInlineWarning)(elem, "Duplicate tests found", "To fix, remove duplicates from \"data-tests\": ".concat(duplicates.map(url => new URL(url).pathname).join(", ")));
      }

      details.classList.add("respec-tests-details", "removeOnSave");
      const uniqueList = [...new Set(testURLs)];
      renderer(_templateObject2(), uniqueList.length, uniqueList.map(toListItem));
      return {
        elem,
        details
      };
    }).forEach(({
      elem,
      details
    }) => {
      delete elem.dataset.tests;
      elem.append(details);
    });
  }
});
//# sourceMappingURL=data-tests.js.map